/* eslint no-console: 0 */
/* global axios */
import ApiClient, {Utility} from '../ApiClient';

export const buildCreatePayload = ({
  message,
  isPrivate,
  contentAttributes,
  echoId,
  files,
  ccEmails = '',
  bccEmails = '',
  toEmails = '',
  forwarded, // d99d
  fromEmail, // d99d
  templateParams,
  delay_hours = null,
}) => {
  let payload;
  if (files && files.length !== 0) {
    payload = new FormData();
    if (message) {
      payload.append('content', message);
    }
    files.forEach(file => {
      payload.append('attachments[]', file);
    });
    payload.append('private', isPrivate);
    payload.append('echo_id', echoId);
    payload.append('cc_emails', ccEmails);
    payload.append('bcc_emails', bccEmails);
    if (forwarded) payload.append('forwarded', forwarded); // d99d
    if (fromEmail) payload.append('from_email', fromEmail); // d99d
    contentAttributes && Utility.convertModelToFormData(contentAttributes, payload, 'content_attributes') // d99d
    if (toEmails) {
      payload.append('to_emails', toEmails);
    }
    if (delay_hours) {
      payload.append('delay_hours', delay_hours);
    }
  } else {
    payload = {
      content: message,
      private: isPrivate,
      echo_id: echoId,
      content_attributes: contentAttributes,
      cc_emails: ccEmails,
      bcc_emails: bccEmails,
      to_emails: toEmails,
      forwarded: forwarded, // d99d
      from_email: fromEmail, // d99d
      template_params: templateParams,
      delay_hours: delay_hours,
    };
  }
  return payload;
};

class MessageApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  create({
    conversationId,
    message,
    private: isPrivate,
    contentAttributes,
    echo_id: echoId,
    files,
    file, // d99d
    ccEmails = '',
    bccEmails = '',
    toEmails = '',
    forwarded, // d99d
    fromEmail, // d99d
    templateParams,
    delay_hours,
  }) {
    return axios({
      method: 'post',
      url: `${this.url}/${conversationId}/messages`,
      data: buildCreatePayload({
        message,
        isPrivate,
        contentAttributes,
        echoId,
        files: file ? [file] : files, // d99d support file, because creating conversation use only single file
        ccEmails,
        bccEmails,
        toEmails,
        forwarded, // d99d
        fromEmail,  // d99d
        templateParams,
        delay_hours,
      }),
    });
  }

  delete(conversationID, messageId) {
    return axios.delete(`${this.url}/${conversationID}/messages/${messageId}`);
  }

  getPreviousMessages({ conversationId, after, before }) {
    const params = { before };
    if (after && Number(after) !== Number(before)) {
      params.after = after;
    }
    return axios.get(`${this.url}/${conversationId}/messages`, { params });
  }

  getFileMessages(id) {
    return axios.get(`${this.url}/${id}/messages/files`);
  }

  getForwardQuoteMessages({ conversationId, messageId, limit }) {
    return axios.get(
      `${this.url}/${conversationId}/messages/${messageId}/forward_quotes`,
      { params: limit ? { limit } : {} }
    );
  }

  translateMessage(conversationId, messageId, targetLanguage) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/translate`,
      {
        target_language: targetLanguage,
      }
    );
  }
}

export default new MessageApi();
